import {createSlice} from '@reduxjs/toolkit';

export const userLeftSidebarSlice = createSlice({
    name: 'counter',
    initialState: {
        isOpen: false,
    },
    reducers: {
        toggle: (state) => {
            state.isOpen = !state.isOpen;
        }
    },
});

export const {toggle} = userLeftSidebarSlice.actions;

export default userLeftSidebarSlice.reducer;